export default {
  path: '/my-fol',
  meta: {
    title: '地面实体店',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/my-fol`),
}



// WEBPACK FOOTER //
// ./src/views/Myfollow/router.js